module.exports = __webpack_public_path__ + "static/img/ic-2.f29d61b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon/ic-2.svg
// module id = piKI
// module chunks = 1